import { CCard, CCardTitle } from '@coreui/react-pro'
import React from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { setCensusFilters } from '../../../../redux/census/censusSlice'

export default function CommonChart({ patients, title }) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  return (
    <div
      className="total-patients"
      onClick={() => {
        dispatch(setCensusFilters({ visitStatusDropdown: [title] }))
        navigate('/census')
      }}
    >
      <CCard className="graph-card chart-card">
        <div className="graphcard-title-container">
          <div className="left-sec">
            <CCardTitle className=" chart-text-title mx-3 mt-2">{title}</CCardTitle>
            {title !== 'Skipped' ? (
              <div
                className={
                  title === 'Available'
                    ? 'Available'
                    : title === 'Completed'
                      ? 'Completed'
                      : 'Incomplete'
                }
              ></div>
            ) : (
              <i
                className="fa-regular fa-ban fa-flip-horizontal"
                style={{ color: 'var(--default-text-color)', fontSize: '0.85em' }}
              ></i>
            )}
          </div>
          <p className="chart-text-title-count">{patients?.length}</p>
        </div>
      </CCard>
    </div>
  )
}
